import { reactTo } from "./react-to.ts";
import { evalFactor, type Factor, type KeyOf } from "./utils.ts";

/** A property has value property, and is also a getter function. */
export type Property<Value> = { 
    value : Value;
    compute : (func: () => Value) => Property<Value>;
} & (() => Value);

/** Create a property from a target object and a property name. */
export const prop = <Target, Value>(
    target : Factor<Target>, 
    prop : KeyOf<Target, Value>
) : Property<Value> => {
    const getTarget = () => evalFactor(target);
    const getProp = () => getTarget()?.[prop];
    
    Object.defineProperty(getProp, "value", {
        get: getProp,
        set: (value : Value) => (getTarget() as any)[prop] = value
    });

    getProp.compute = (funct : () => Value) => { 
        reactTo(() => getTarget() && funct())
            .with((value : Value | undefined) => { 
                if(getTarget()) {
                    (getTarget() as any)[prop] = value; 
                }
            }); 
        return getProp;
    };

    return getProp as Property<Value>;
}